import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Fragment as _Fragment, withModifiers as _withModifiers, renderList as _renderList, mergeProps as _mergeProps, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "header-left-drawer"
}
const _hoisted_2 = { id: "header-left" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex align-center minus-left"
}
const _hoisted_4 = {
  key: 1,
  class: "d-flex align-center flex-nowrap"
}
const _hoisted_5 = { id: "header-center" }
const _hoisted_6 = {
  key: 0,
  class: "d-flex align-center"
}
const _hoisted_7 = { class: "cart-badge" }
const _hoisted_8 = {
  key: 1,
  class: "d-flex align-center"
}
const _hoisted_9 = { class: "cart-badge" }

import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { checkMobile } from '../../utils/utils'
import theme from '../../utils/theme'
import HeaderUser from './HeaderUser.vue'
import HeaderNotification from './HeaderNotification.vue'
import HeaderLeftMenuMobile from './HeaderLeftMenuMobile.vue'
import HeaderLeftMenuWeb from './HeaderLeftMenuWeb.vue'
import ButtonReload from '../atoms_molecules/ButtonReload.vue'
import { userState } from '../../stores/user'
import { headerState } from '../../stores/header'
import { menuState } from '../../stores/menu'
import Menu from '../../../api/v2/models/menu'
import { ROUTER_NAME } from '../../router'
import CartApi from '../../../api/v2/api/cart'


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderPageDefault',
  setup(__props) {

const cartApiInstance = new CartApi()
const route = useRoute()
const router = useRouter()

const mobile = ref(checkMobile())
const drawer = ref(true)
const right = ref(null)
const left = ref(null)
const cartItemCount = ref(0)

const user = computed(() => userState.user)
const schoolSetting = computed(() => headerState.schoolSetting)
const headerTitle = computed(() => headerState.headerTitle)

const headerNavTextColor = computed(() => {
  if (schoolSetting.value) {
    return schoolSetting.value.navTextColor
  }
})

const hamburgerColor = computed(() => {
  if (schoolSetting.value) {
    return `color: ${schoolSetting.value.hamburgerColor}`
  } else {
    return "color: white"
  }
})

const headerNavColor = computed(() => {
  if (schoolSetting.value) {
    return schoolSetting.value.navColor
  } else {
    return theme.headerBackgroundColor
  }
})

const hideDefaultMenu = computed(() => {
  return route && route.meta && route.meta.hideDefaultMenu === true
})

const hideDefaultHeader = computed(() => {
  return route && route.meta && route.meta.hideDefaultHeader === true
})

const menus = computed(() => menuState.filteredMenus)
const pageTitle = computed(() => route.meta ? route.meta.title : null)

const fetchCartData = async () => {
  cartItemCount.value = await cartApiInstance.getCartItemCount()
}

const goToCart = () => {
  window.location.href = '/purchase/cart'
}

const redirect = (routerPath: any) => {
  router.push(routerPath)
}

const reload = () => {
  router.go(router.currentRoute.value as any)
}

const toMenu = (menu: Menu) => {
  if ((!menu.kbn.includes("LINK") && (menu.url != "")) || menu.isTargetBlank) {
    window.open(menu.url, '_blank')
  } else {
    window.location.href = menu.url
  }
}

const toExamShow = () => {
  if (user.value && user.value != null && user.value.isGuestExamOnly) {
    location.href = `/exams/${route.params.examId}`
    return
  }
}

onMounted(async () => {
  drawer.value = !mobile.value
  await headerState.getSchoolSetting()
  fetchCartData()
})

onBeforeUnmount(() => {
  // No need to clear interval since we're not using it anymore
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["header-main", { 'header-hidden': hideDefaultHeader.value && hideDefaultMenu.value }])
  }, [
    _createCommentVNode(" Navigation Drawer MUST come BEFORE v-app-bar in Vuetify 3 for proper layout "),
    (!hideDefaultMenu.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (mobile.value)
            ? (_openBlock(), _createBlock(HeaderLeftMenuMobile, {
                key: 0,
                modelValue: drawer.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((drawer).value = $event))
              }, null, 8 /* PROPS */, ["modelValue"]))
            : (_openBlock(), _createBlock(HeaderLeftMenuWeb, {
                key: 1,
                modelValue: drawer.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((drawer).value = $event))
              }, null, 8 /* PROPS */, ["modelValue"]))
        ]))
      : _createCommentVNode("v-if", true),
    (!hideDefaultHeader.value)
      ? (_openBlock(), _createBlock(_component_v_app_bar, {
          key: 1,
          color: headerNavColor.value,
          dark: "",
          class: _normalizeClass({ 'header-mobile': mobile.value })
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (!hideDefaultHeader.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    (user.value && user.value != null && user.value.isGuestExamOnly)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_v_btn, {
                            class: "mk-0",
                            icon: "",
                            onClick: toExamShow
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                  _createTextVNode("mdi-chevron-left", -1 /* CACHED */)
                                ]))]),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _: 1 /* STABLE */
                          }),
                          _createVNode(_component_v_toolbar_title, {
                            class: _normalizeClass({ 'ps-0': mobile.value }),
                            style: _normalizeStyle({'color': headerNavTextColor.value})
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(headerTitle.value), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["class", "style"])
                        ], 64 /* STABLE_FRAGMENT */))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createCommentVNode(" Hamburger icon at the beginning of header (both mobile and web) "),
                          _createVNode(_component_v_app_bar_nav_icon, {
                            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (drawer.value = !drawer.value), ["stop"])),
                            style: _normalizeStyle(hamburgerColor.value)
                          }, null, 8 /* PROPS */, ["style"]),
                          (mobile.value)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                style: _normalizeStyle({ 'color': headerNavTextColor.value })
                              }, _toDisplayString(pageTitle.value), 5 /* TEXT, STYLE */))
                            : _createCommentVNode("v-if", true),
                          _createCommentVNode(" On web: show menu items only (no school name) "),
                          (!mobile.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menus.value, (menu) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, {
                                    key: menu.url
                                  }, [
                                    (menu.kbn == 'MENU_KBN_MENU')
                                      ? (_openBlock(), _createBlock(_component_v_menu, { key: 0 }, {
                                          activator: _withCtx(({ props }) => [
                                            _createVNode(_component_v_btn, _mergeProps({ variant: "text" }, { ref_for: true }, props, {
                                              style: { 'color': headerNavTextColor.value },
                                              class: "menu-view-name text-none"
                                            }), {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(menu.viewName) + " ", 1 /* TEXT */),
                                                _createVNode(_component_v_icon, { end: "" }, {
                                                  default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                                    _createTextVNode("mdi-chevron-down", -1 /* CACHED */)
                                                  ]))]),
                                                  _: 1 /* STABLE */
                                                })
                                              ]),
                                              _: 2 /* DYNAMIC */
                                            }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["style"])
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_list, { class: "sub-menu-dropdown" }, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.menuItems, (menuItem) => {
                                                  return (_openBlock(), _createBlock(_component_v_list_item, {
                                                    key: menuItem.url,
                                                    onClick: ($event: any) => (toMenu(menuItem))
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_list_item_title, { class: "menu-view-name" }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(menuItem.viewName), 1 /* TEXT */)
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                      }, 1024 /* DYNAMIC_SLOTS */)
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
                                                }), 128 /* KEYED_FRAGMENT */))
                                              ]),
                                              _: 2 /* DYNAMIC */
                                            }, 1024 /* DYNAMIC_SLOTS */)
                                          ]),
                                          _: 2 /* DYNAMIC */
                                        }, 1024 /* DYNAMIC_SLOTS */))
                                      : (_openBlock(), _createBlock(_component_v_btn, {
                                          key: 1,
                                          variant: "text",
                                          onClick: ($event: any) => (toMenu(menu)),
                                          style: _normalizeStyle({ 'color': headerNavTextColor.value }),
                                          class: "menu-view-name text-none"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(menu.viewName), 1 /* TEXT */)
                                          ]),
                                          _: 2 /* DYNAMIC */
                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick", "style"]))
                                  ], 64 /* STABLE_FRAGMENT */))
                                }), 128 /* KEYED_FRAGMENT */))
                              ]))
                            : _createCommentVNode("v-if", true)
                        ], 64 /* STABLE_FRAGMENT */))
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            _createVNode(_component_v_spacer),
            _createElementVNode("div", _hoisted_5, [
              (!hideDefaultHeader.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (mobile.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createCommentVNode(" <ButtonReload @click=\"reload\" /> "),
                          _createVNode(HeaderNotification, { colorNotiIcon: headerNavTextColor.value }, null, 8 /* PROPS */, ["colorNotiIcon"]),
                          (cartItemCount.value > 0)
                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                key: 0,
                                icon: "",
                                onClick: goToCart,
                                class: "position-relative mx-2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, { color: headerNavTextColor.value }, {
                                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                      _createTextVNode("mdi-cart", -1 /* CACHED */)
                                    ]))]),
                                    _: 1 /* STABLE */
                                  }, 8 /* PROPS */, ["color"]),
                                  _createElementVNode("span", _hoisted_7, _toDisplayString(cartItemCount.value), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                              }))
                            : _createCommentVNode("v-if", true),
                          _createVNode(HeaderUser)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createVNode(HeaderNotification, { colorNotiIcon: headerNavTextColor.value }, null, 8 /* PROPS */, ["colorNotiIcon"]),
                          (cartItemCount.value > 0)
                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                key: 0,
                                icon: "",
                                onClick: goToCart,
                                class: "position-relative mx-2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, { color: headerNavTextColor.value }, {
                                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                      _createTextVNode("mdi-cart", -1 /* CACHED */)
                                    ]))]),
                                    _: 1 /* STABLE */
                                  }, 8 /* PROPS */, ["color"]),
                                  _createElementVNode("span", _hoisted_9, _toDisplayString(cartItemCount.value), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                              }))
                            : _createCommentVNode("v-if", true),
                          _createVNode(HeaderUser)
                        ]))
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true)
            ]),
            _cache[7] || (_cache[7] = _createElementVNode("div", { id: "header-right" }, null, -1 /* CACHED */))
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["color", "class"]))
      : _createCommentVNode("v-if", true),
    _cache[8] || (_cache[8] = _createElementVNode("div", { id: "header-right-drawer" }, null, -1 /* CACHED */))
  ], 2 /* CLASS */))
}
}

})